import { getLeFEOrigin } from '@utils/util';

export const FinanceAdjustLeFE = () => (
    <iframe
        className="admin-iframe"
        title="转调账记录"
        src={`${getLeFEOrigin()}/#/runtime/admin/finance_adjust_list`}
    />
);
